import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=050c812d&scoped=true&lang=pug&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=050c812d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c812d",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230925165443%2Fcomponents%2Fsite%2Fblog%2Farticle%2Faside.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CtasFeaturedCard: require('/home/ubuntu/nuxt/bonkers/releases/20230925165443/components/ctas/featured-card.vue').default})
